import { createAction } from '@reduxjs/toolkit'
import isNull from 'lodash/isNull'
import isUndefined from 'lodash/isUndefined'
import { SagaIterator } from 'redux-saga'
import { call, put, select } from 'redux-saga/effects'

import { SET_DRAWABLES, setActiveDrawableGroup } from '../../../actions/drawable'
import { createOpeningGroupMaterial } from '../../../api/projects-api'
import { OpeningGroupAPI } from '../../../models/activeDrawable'
import { Building } from '../../../models/projectBuilding'
import { determineDefaultBundleForNewGroup } from '../../../shared/services/drawable-type-service'
import { selectActiveBuildingFromActiveFloor } from '../../slices/buildings'
import { createBlankGroup } from '../../slices/geometry'
import { selectIsMaterialGroupActivationBlocked } from '../../slices/masterSetPlan'
import { CreateDrawableGroupActionInput, Drawables } from '../../types'

export const setDrawables = createAction<Drawables>(SET_DRAWABLES)

export function* handleCreateDrawableForGroup(input: CreateDrawableGroupActionInput): SagaIterator<void> {
    try {
        const isGroupActivationBlocked: boolean = yield select(selectIsMaterialGroupActivationBlocked)

        if (isGroupActivationBlocked) return

        const activeBuilding: Building | undefined = yield select(selectActiveBuildingFromActiveFloor)

        if (isUndefined(activeBuilding) || isNull(input.project)) {
            yield call(console.error, 'Cannot create a drawable group: active building or project is not loaded')

            return
        }

        const newDrawableGroup: OpeningGroupAPI = yield call(
            createOpeningGroupMaterial,
            input.project.id,
            undefined,
            {
                ...input.settings,
                name: `temporary_${input.type}_group`,
                rcm_building_id: activeBuilding.rcm_id,
                bundle_name: determineDefaultBundleForNewGroup(input.type),
                modelId: input.project.currentModelId ? input.project.currentModelId : undefined,
            },
            input.type
        )

        const drawableGroupWBlankOpenings = {
            ...newDrawableGroup,
            openings: [],
            drawables: [],
        }

        yield put(createBlankGroup(drawableGroupWBlankOpenings))
        yield put(setActiveDrawableGroup({ ...drawableGroupWBlankOpenings, drawablesPerTab: [], isActive: {} }))
    } catch (e) {
        yield call(console.error, e)
    }
}
